<template>
	<div class="schedule-day">
		<h3>{{ day }}</h3>
		<div v-for="item in timelineItems" :key="item.index">
			<div class="schedule-item">
				<v-layout
					align-center
					justify-start
					row
					wrap
					fill-height
					class="schedule-pad-left"
				>
					<v-flex xs12 md2>
						<div class="schedule-item-time">{{ item.time }}</div>
					</v-flex>
					<v-flex xs12 md4>
						<div v-if="item.chairs != null" class="schedule-item-chairs">Chair(s): {{ item.chairs }}</div>
					</v-flex>
					<v-flex xs12 md6>
						<div class="schedule-item-title">{{ item.title }}</div>
					</v-flex>
					<v-flex xs12 md4>
						<div class="schedule-item-location">
							{{ item.location }}
						</div>
					</v-flex>
					<v-flex xs12 md2>
						<div class="schedule-item-pdfLink">
							{{ item.pdfLink }}
						</div>
					</v-flex>
				</v-layout>
			</div>
			<div v-if="item.sessions" class="schedule-item-sessions">
				<div
					v-for="session in item.sessions"
					:key="session.index"
					class="schedule-item-session"
				>
					<v-layout
						align-center
						justify-start
						row
						wrap
						fill-height
						class="schedule-pad-left"
					>
						<v-flex xs12 md6>
							<div class="session-title">{{ session.title }}</div>
						</v-flex>
						<v-flex xs12 md3>
							<div class="session-speaker">
								{{ session.speaker }}
							</div>
						</v-flex>
						<v-flex xs12 md3>
							<div class="session-institution">
								{{ session.institution }}
							</div>
						</v-flex>
					</v-layout>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'Timeline',
	props: {
		day: String,
		timelineItems: Array,
		isSession: Boolean
	}
};
</script>
<style src="../style.css"></style>
